import { reevaluateUserIdentityConflict } from '~src/app/actions/spaces/UserIdentityActions';
import { IUserIdentityConflictInfo } from '~src/authentication/models/IUserIdentityConflictInfo';

import { Messages } from '../../../../codegen/Localize';
import { AppState } from '../../../state/AppState';
import { EntityActionNames, IEntityAction } from './IEntityAction';

export const ReevaluateUserIdentityConflictAction: IEntityAction<IUserIdentityConflictInfo, {}> = {
  name: EntityActionNames.ReevaluateUserIdentityConflict,
  translateName: Messages.identityMigration_ReevaluateUserIdentityConflict,
  isVisible: (targetItems: IUserIdentityConflictInfo[], state: AppState) => true,
  isClickable: areAllConflictsAcknowledged,
  createReduxAction: (targetItems: IUserIdentityConflictInfo[]) => reevaluateUserIdentityConflict(targetItems)
};

function areAllConflictsAcknowledged(availableActions: {}, targetItems: IUserIdentityConflictInfo[], state: AppState): boolean {
  return targetItems.every(x => x.acknowledged);
}
